import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { BossCallMapping } from 'src/app/models/commission/boss-call-mapping.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { UserManagementModel } from 'src/app/models/userManagementModel/usermang.model';
import { CommissionService } from 'src/app/service/commission.service';
import { GlobalService } from 'src/app/service/global.service';
import { NotificationService } from 'src/app/service/notification.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { BossCallMappingService } from 'src/app/service/bosscallmapping.service';


@Component({
  selector: 'app-boss-call-mapping',
  templateUrl: './boss-call-mapping.component.html',
  styleUrls: ['./boss-call-mapping.component.css']
})
export class BossCallMappingComponent implements OnInit {

  ordersTableColumns: TableColumn[];
  columnsData: any;
  actions: any;
  actionButtons: any;
  callMapingDetails: BossCallMapping[] = [];
  editCallMapingDtls = new BossCallMapping();
  emailDtls = new BossCallMapping();
  IsmodelShow: boolean = false;
  isAccessDisabled: boolean = false;
  ishidemail: boolean = true;
  excelCallMappingData: BossCallMapping[] = [];
  menusFilter: UserManagementModel[] = [];
  isView: boolean = true;
  permissionCheck: any;
  errorMessage: string;

  columnsExcelData: any;
  dataForExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];

  constructor(private bossCallMappingService:BossCallMappingService,private commissionService: CommissionService, private datePipe: DatePipe, private globalService: GlobalService,
    public ete: ExportExcelService, private httpService: HttpClient, private notificationService: NotificationService) { }

  public bossCallMappingModel = new BossCallMapping();

  ngOnInit(): void {
    this.bossCallMappingModel.valid_from_dt
    this.isAccessDisabled = this.globalService._permissionCheck('comm-plan');
    if (this.isAccessDisabled)
      this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.CallMapping;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {
    console.log("called exportExcel" + this.excelCallMappingData);
    for (let js of this.excelCallMappingData) {
      delete js.id;
      delete js.feedDate;
      delete js.email_id;
      console.log("inside for" + js.last_name);
    }

    this.dataForExcel = [];
    let reportData = null;
    this.excelCallMappingData.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row));
      console.log("inside excel" + this.dataForExcel);
    })
    
     reportData = {
      title: 'Boss Call Mapping Details',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.ete.exportExcel(reportData);
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }
  onChangeFeedDt() {
    this.getEmail();
    this.ishidemail = false;
    this.bossCallMappingService.getSearchResults(this.datePipe.transform
      (this.bossCallMappingModel.feedDate, "yyyy-MM-dd"))
      .subscribe((data: BossCallMapping[]) => {
        this.callMapingDetails = data;
        this.excelCallMappingData = JSON.parse(JSON.stringify(data));
        this.initializeColumns();
        this.initializeExcelHeaders();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public onAddCall(kpiForm: NgForm): void {
    console.log("======= ", this.bossCallMappingModel);
    this.bossCallMappingService.saveCallMapData(this.bossCallMappingModel)
      .subscribe(response => {
        if (response) {
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Record added successfully`);
          kpiForm.reset();
          document.getElementById('closeAddKPIButton').click();
          this.onChangeFeedDt();
        }
        else
          this.notificationService.sendNotification(NotificationType.ERROR, 'Some Issue Occured');

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }

  public onupdatecall(editCallForm: NgForm): void {
    this.bossCallMappingService.updateCallMapData(this.editCallMapingDtls)
      .subscribe(response => {
        //response = response as ErrorResponseMessage;
        if (response) {
          this.notificationService.sendNotification(NotificationType.SUCCESS,
            `CommissionPlan Updated successfully`);
          document.getElementById('editCallButton').click();
          this.onChangeFeedDt();
        }
        else
          this.notificationService.sendNotification(NotificationType.ERROR, 'Some Issue Occured');
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }

  public addEmails(editCallForm: NgForm): void {
    console.log("add Emails was called");
    this.bossCallMappingService.saveEmailId(this.emailDtls)
      .subscribe(response => {
        if (response) {
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Email added successfully`);

          this.onChangeFeedDt();
        }
        else
          this.notificationService.sendNotification(NotificationType.ERROR, 'Some Issue Occured');
        console.log(this.bossCallMappingModel.email_id);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }

  public sendEmail(editCallForm: NgForm): void {
    console.log("send Emails was called");
    this.bossCallMappingService.sendEmail(this.bossCallMappingModel)
      .subscribe(response => {
        if (response) {
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Email added successfully`);

          this.onChangeFeedDt();
        }
        else
          this.notificationService.sendNotification(NotificationType.ERROR, 'Some Issue Occured');
        console.log(this.bossCallMappingModel.email_id);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }

  public getEmail() {
    this.bossCallMappingService.getEmail()
      .subscribe((response) => {
        console.log("inside response");

        this.emailDtls.email_id = response;

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }



  close(kpiForm: NgForm, id: string) {
    console.log('======', kpiForm);
    if (confirm("Do you want to close the popup without saving?")) {
      this.IsmodelShow = true;
      kpiForm.reset();
      document.getElementById(id).click();
    }
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.CallMappingData;
        console.log(this.ordersTableColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
    this.actions = [
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Delete',
        dataKey: 'far fa-trash-alt danger f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      }

    ],
      this.actionButtons = [

        {
          name: 'Add',
          class: 'btn btn-default '
        }
      ]
  }

  public redirect(url: string) {

    // if (url === 'kpi-master')
    //   this.router.navigate(['/' + url], { queryParams: { page: 'replicate-plan' } });
    // else
    //   this.router.navigate(['/' + url]);
  }

  actionOnButton(action: any) {
    if (!this.isAccessDisabled) {
      this.IsmodelShow = false;
      document.getElementById(action).click();
    }
  }

  rowAction(row: any) {
    console.log(row);
    this.editCallMapingDtls = row.row;
    if (!this.isAccessDisabled) {
      if (row.value === 'Update') {
        this.IsmodelShow = false;
        document.getElementById(row.value).click()
      } else if (row.value === 'Delete') {
        this.IsmodelShow = false;
        this.editCallMapingDtls = row.row;
        if (confirm("Are you sure to delete this Record")) {
          this.bossCallMappingService.deleteCallMapData(this.editCallMapingDtls.network_id, this.editCallMapingDtls.valid_from_dt).subscribe(
            (response: CustomHttpRespone) => {
              this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
              this.onChangeFeedDt();
            }, (errorResponse: HttpErrorResponse) => {
              var msg: any;
              msg = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            }
          )
        }
      }
    } else {
      this.errorMessage = 'Edit Permission has Disabled Please Contact Admin';
    }
  }

  innerRowAction(row: any) {
    console.log(" row ....", row);
    if (row.value === 'Delete') {
      //this.onDeleteCommDetailValues(row.row.id);
    }
  }

}
